export default "__VITE_ASSET__BtXFHo32__"